import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { SalesChartComponent } from "../charts";
import { Dropdown } from "react-bootstrap";

export default function SalesCardComponent() {
  const { t } = useContext(TranslatorContext);

  return (
    <div className="mc-sales-card" style={{ height: "350px" }}>
      <div className="mc-sales-card-group">
        <div className="mc-card-header">
          <h4 className="mc-card-title">{t("Families Set Free")}</h4>
        </div>
        <div className="mc-sales-card-amount trending_up green">
          <h3>$3,787,681.00</h3>
          <p>
            40.63%
            <i className="material-icons">trending_up</i>
          </p>
        </div>
        <p className="mc-sales-card-compare">$3,578.90 in {t("last_month")}</p>
      </div>
    </div>
  );
}
